'use client'

import _ from 'lodash'
import { twMerge } from 'tailwind-merge'
import { Menu, MenuButton, MenuItems } from '@headlessui/react'
import { EllipsisVerticalIcon } from '@heroicons/react/20/solid'

type Props = {
  buttonSize?: string
  children: React.ReactNode
}

export function DropdownMenu({ buttonSize, children }: Props) {
  return (
    <Menu as='div' className='relative z-40'>
      <MenuButton className='focus:outline-none'>
        <EllipsisVerticalIcon className={buttonSize || 'size-6'} />
      </MenuButton>
      <MenuItems transition={true} modal={false}
        className={
          twMerge(
            'absolute right-0 z-50 py-1 origin-top-right rounded divide-y',
            'bg-white dark:bg-zinc-800 border shadow-lg',
            'data-closed:scale-95 data-closed:transform data-closed:opacity-0',
            'focus:outline-none'
          )}
      >
        {children}
      </MenuItems>
    </Menu>
  )
}

